import Image from "next/legacy/image";
import { blurDataURL } from "../../../utils/constants/images";
import Badge from "../../common/Badge";
import { DividerH } from "../../common/RedDividerH";

const PlayerProfileCard = ({ player }) => {
  return (
    <div className="w-full aspect-w-1 aspect-h-1 bg-black rounded-md overflow-hidden xl:aspect-w-7 xl:aspect-h-8 transform transition duration-500 hover:scale-105">
      <div className="absolute w-full h-full object-center object-cover group-hover:opacity-75">
        <Image
          src={player.player_picture}
          alt="Player Avatar"
          objectFit="fill"
          layout="fill"
          quality={100}
          placeholder="blur"
          blurDataURL={blurDataURL}
        />
      </div>
      <div
        aria-hidden="true"
        className="w-full bg-gradient-to-b from-transparent to-black opacity-100 absolute sm:absolute sm:inset-0"
      ></div>
      <div className="p-6 flex items-end absolute inset-0">
        {player.player_status && <Badge categoryName={player.player_status} />}
        <div>
          <h3 className="mt-2 mb-1 ml-[10px] font-semibold text-white text-sm">
            {player.player_jersey_number}
          </h3>
          <DividerH />

          <h3 className="mt-2 mb-2 font-semibold text-white text-base truncate">
            {player.player_first_name}
          </h3>

          <span className="absolute bottom-3 left-[24px] right-[24px] font-semibold text-white text-base truncate">
            {player.player_last_name}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PlayerProfileCard;

export const LoanPlayerProfileCard = ({ player }) => {
  return (
    <div className="w-full aspect-w-1 aspect-h-1 bg-black rounded-md overflow-hidden xl:aspect-w-7 xl:aspect-h-8 transform transition duration-500 hover:scale-105">
      <div className="absolute w-full h-full object-center object-cover group-hover:opacity-75">
        <Image
          src={player.player_picture}
          alt="Player Avatar"
          objectFit="fill"
          layout="fill"
          quality={100}
          placeholder="blur"
          blurDataURL={blurDataURL}
        />
      </div>
      <div
        aria-hidden="true"
        className="w-full bg-gradient-to-b from-transparent to-black opacity-100 absolute sm:absolute sm:inset-0"
      ></div>
      <div className="p-6 flex items-end absolute inset-0">
        {/* {player.player_status && <Badge categoryName={player.player_status} />} */}
        <div>
          {/* <h3 className="mt-2 mb-1 ml-[10px] font-semibold text-white text-sm">
            {player.player_jersey_number}
          </h3> */}
          <DividerH />

          <h3 className="mt-2 mb-2 font-semibold text-white text-base truncate">
            {player.player_first_name}
          </h3>

          <span className="absolute bottom-3 left-[24px] right-[24px] font-semibold text-white text-base truncate">
            {player.player_last_name}
          </span>
        </div>
      </div>
    </div>
  );
};
